import React, {useEffect, useState} from "react";
import associateServices from "../../services";
import SlideGameItem from "../slide-game-item";
import {useTranslation} from "react-i18next";
import {Link, useNavigate} from "react-router-dom";
import SvgIcon from "../svg-icon";
import {useSelector} from "react-redux";
import StyleHelper from "../../helpers/styleHelper";
import './index.css'
import {Navigation} from "swiper/modules";
import {Swiper, SwiperSlide} from "swiper/react";
import 'swiper/css/grid';
import {points} from "../../helpers/splide-helper";
import store from "../../reducers/createReducers";
import DataActions from "../../actions/data-actions";

const TopGames = () => {
    const {t} = useTranslation();
    const [data, setData] = useState([]);
    const [coloredData, setColoredData] = useState([]);
    const [loading, setLoading] = useState(true);
    const {configuration} = useSelector(state => state.globalReducer);
    const {topGames,topGamesDone} = useSelector(state => state.dataReducer);

    // const currentLanguage = i18n.language; // Get the current language
    const navigate = useNavigate();

    useEffect(() => {
        if (!topGamesDone && topGames?.length <= 0) {
            setLoading(true);
            associateServices.getDashboardSlideGames({
                type: 'top'
            }).then(handleResponse); // Stop loading once the response is handled
        }
    }, [topGames,topGamesDone]);


    useEffect(() => {
        setData(topGames)
    }, [topGames])
    useEffect(() => {
        setColoredData(data?.map(oo => ({
            ...oo,
            color: oo.color === 'random' ? StyleHelper.getRandomColor() : oo.color
        })))
    }, [data]);

    const handleResponse = (res) => {
        // setData(res?.data || []);
        setLoading(false);


        store.dispatch(DataActions.setTopGames(res?.data || []))

    };




    const handleNavigation = path => navigate(path);


    if (!loading && data?.length <= 0)
        return null;


    return (
        <div className="section section--first" id="top-games-wrapper">
            <div className="container">
                <div className="col-12">
                    <div className="section__title-wrap">
                        <h2 className="section__title">
                            <SvgIcon id={'top-games'}/>
                            {t('groups.top-games')}
                        </h2>

                        {/*<Link*/}
                        {/*    to={stringHelper.getLocalizedPath(currentLanguage, '/casino/group/top-games')}*/}
                        {/*    className="section__view section__view--carousel">*/}
                        {/*    {t('general.view-all')}*/}
                        {/*</Link>*/}
                    </div>
                </div>

                {
                    coloredData?.length >= 1 &&
                    <div className="d-flex flex-column gap-2">
                        <Swiper
                            id="top-games-swiper"
                            modules={[Navigation]}
                            navigation
                            spaceBetween={4} // Space between slides
                            slidesPerView={3.5} // This defines 2 slides per row
                            grid={{
                                fill: "row", // Ensures rows are filled row by row
                            }}
                            breakpoints={points}
                            loop={true}
                            autoplay={{
                                delay: 5000,
                                disableOnInteraction: false,
                            }}
                            className="top-games-top"
                        >
                            {coloredData?.map((game, i) => (
                                <SwiperSlide key={i}>
                                    <SlideGameItem
                                        game={game}
                                        onClick={handleNavigation}
                                        index={i}
                                        showCount={false}
                                        passive={game?.blacklist?.includes(configuration.country)}
                                    />
                                </SwiperSlide>
                            ))}
                        </Swiper>

                        {/*<Swiper*/}
                        {/*    spaceBetween={8} // Space between slides*/}
                        {/*    slidesPerView={3} // This defines 2 slides per row*/}
                        {/*    grid={{*/}
                        {/*        fill: "row", // Ensures rows are filled row by row*/}
                        {/*    }}*/}
                        {/*    breakpoints={points}*/}
                        {/*    loop={true}*/}
                        {/*    autoplay={{*/}
                        {/*        delay: 5000,*/}
                        {/*        disableOnInteraction: false,*/}
                        {/*    }}*/}
                        {/*    className="top-games-bottom"*/}
                        {/*>*/}
                        {/*    {shuffled?.map((game, i) => (*/}
                        {/*        <SwiperSlide key={i}>*/}
                        {/*            <SlideGameItem*/}
                        {/*                game={game}*/}
                        {/*                onClick={handleNavigation}*/}
                        {/*                index={i}*/}
                        {/*                showCount={false}*/}
                        {/*                passive={game?.blacklist?.includes(configuration.country)}*/}
                        {/*            />*/}
                        {/*        </SwiperSlide>*/}
                        {/*    ))}*/}
                        {/*</Swiper>*/}
                    </div>
                }

            </div>
        </div>
    )
        ;
};

export default React.memo(TopGames);
